import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41ed994c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deadline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deadline-head" }, "報名截止時間", -1))
const _hoisted_3 = { class: "deadline-body" }
const _hoisted_4 = { class: "demands" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "demands-head" }, "需求", -1))
const _hoisted_6 = { class: "demands-body" }
const _hoisted_7 = { class: "pay" }
const _hoisted_8 = { class: "pay-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pay-content-label" }, "基本薪：", -1))
const _hoisted_10 = { class: "pay-content-value" }
const _hoisted_11 = {
  key: 0,
  class: "condition"
}
const _hoisted_12 = {
  key: 1,
  class: "condition condition--blue"
}
const _hoisted_13 = { class: "action" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("已報名")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("報名")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_JobListItemTemplate = _resolveComponent("JobListItemTemplate")!

  return (_openBlock(), _createBlock(_component_JobListItemTemplate, _normalizeProps(_guardReactiveProps({ job: _ctx.job })), {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.job.deadline), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.job.demands) + "位", 1)
      ])
    ]),
    tail: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.job.basicPay), 1)
        ]),
        (_ctx.job.hasAdditionalConditions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 另有額外達標 "))
          : (_ctx.job.hasRequiredConditions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 查看必要條件 "))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.job.isRegistered)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              disabled: ""
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              onClick: slotProps.showDetail
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 2
            }, 1032, ["onClick"]))
      ])
    ]),
    _: 1
  }, 16))
}